import React from 'react';
import SidebarProducts from './Sidebar/SidebarProductsV2';
import SidebarFooter from './Sidebar/SidebarFooter';
import useWindowSize from '../hooks/useWindowSize';

export default ({ isExpanded, toggleExpanded, products, showNested = false }) => {
  const { width } = useWindowSize();

  if (!products || products.length === 0) return null;
  if (width < 1100 && !isExpanded) return null;

  return (
    <div className="sidebar small no-print" onClick={width < 1100 ? toggleExpanded : undefined}>
      <div className="sidebar-container">
        <div className="sidebar-top text-right">
          <span className="button transparent icon-close no-text gray-dark" />
        </div>
        <div className="sidebar-content">
          <SidebarProducts
            showNested={showNested}
            items={products}
            mobile={width < 1100}
            isOpen={isExpanded}
          />
        </div>
        <SidebarFooter toggle={toggleExpanded} isOpen={isExpanded} />
      </div>
    </div>
  );
};
